/* Operator.ts */

export enum Operator {
  BASIC = "basic",
  AND = "and",
  OR = "or",
}
